module.exports = __webpack_public_path__ + "static/home_ch_suite-b883e2355293061a470cfe51ce8a0208.jpg";